import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-items-modal',
  template: `
  <h2 mat-dialog-title>Select Items to Add</h2>
  <mat-dialog-content>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th style="width:34px;">
            <input type="checkbox" (change)="toggleAll($event)" />
          </th>
          <th>Line</th>
          <th>Item</th>
          <th>Mfgr</th>
          <th>Serial</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let i of items">
          <td><input type="checkbox" [(ngModel)]="i.selected" /></td>
          <td>{{ i.soline }}</td>
          <td>{{ i.item }}</td>
          <td>{{ i.manufacturer }}</td>
          <td>{{ i.serialNumber }}</td>
          <td>{{ i.description }}</td>
        </tr>
      </tbody>
    </table>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="confirm()">Add Selected</button>
  </mat-dialog-actions>
  `,
})
export class SelectItemsModalComponent {
  items: any[] = [];

  constructor(
    private dialogRef: MatDialogRef<SelectItemsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.items = data.items || [];
  }

  toggleAll(event: any) {
    const checked = event.target.checked;
    this.items.forEach(i => i.selected = checked);
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    const selected = this.items.filter(i => i.selected);
    this.dialogRef.close(selected);
  }
}
